import React from "react";
import { Container, Row, Col } from "reactstrap";
import ProductCard from "./ProductCard";
import DedicatedComparison from "./DedicatedComparison";
import { PRODUCT_CATEGORIES } from "../data/products";
import "./ProductSection.css";

const sectionConfig = {
  dedicated: {
    title: "Noodle Dedicated Instances",
    icon: "fa-server",
    description: "Powerful dedicated hardware for demanding workloads.",
    disclaimer: "These are bare metal servers with Windows 10.",
  },
  cloud: {
    title: "Noodle Cloud Processing",
    icon: "fa-cloud",
    description: "Flexible cloud capacity, managed for you.",
    disclaimer: null,
  },
  devop: {
    title: "Noodle DevOp",
    icon: "fa-user-tie",
    description: "A dedicated DevOps professional who deploys and configures your environments. Monthly plans—what they can do is listed below.",
    disclaimer: null,
  },
  remote: {
    title: "Noodle Remote Desktop",
    icon: "fa-desktop",
    description: "Secure remote desktop access with fast servers and free P2P. Premium tier, unlimited connection time.",
    disclaimer: null,
  },
};

const ProductSection = ({ category, products }) => {
  const config = sectionConfig[category] || { title: category, icon: "fa-box", description: "" };

  const isDedicated = category === PRODUCT_CATEGORIES.DEDICATED;
  const sectionId =
    isDedicated ? "hn-plans" :
    category === PRODUCT_CATEGORIES.CLOUD ? "hn-plans-cloud" :
    category === PRODUCT_CATEGORIES.DEVOP ? "hn-plans-devop" :
    category === PRODUCT_CATEGORIES.REMOTE_DESKTOP ? "hn-plans-remote" : undefined;

  return (
    <section className="hn-product-section" id={sectionId}>
      <Container>
        <div className="hn-section-header text-center mb-4">
          <i className={`fas ${config.icon} hn-section-icon`} aria-hidden="true" />
          <h2 className="hn-section-title">{config.title}</h2>
          {config.description && (
            <p className="hn-section-desc text-muted">{config.description}</p>
          )}
          {config.disclaimer && (
            <p className="hn-section-disclaimer text-muted small mt-2 mb-0">
              <i className="fas fa-info-circle me-1" aria-hidden="true" />
              {config.disclaimer}
            </p>
          )}
          <p className="hn-section-guarantee text-muted small mt-2 mb-0">
            <i className="fas fa-chart-line me-1" aria-hidden="true" />
            97% uptime target · Refund within 3 days if not yet deployed (see Refund Policy)
          </p>
        </div>
        {isDedicated && <DedicatedComparison />}
        <Row className="g-4">
          {products.map((product) => (
            <Col key={product.id} xs="12" sm="6" lg={products.length === 1 ? 12 : 6} xl={products.length >= 4 ? 3 : products.length === 1 ? 12 : 6}>
              <ProductCard product={product} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ProductSection;
